import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@produzionejb/ui';
import { Link } from 'react-router-dom';
import { useLots } from '../../../lib/lots-api';

export function LotResiduoWidget() {
  const { t } = useTranslation();
  const lotsQ = useLots({ status: 'ACTIVE', pageSize: 200 });
  const top = (lotsQ.data?.items ?? [])
    .filter((l) => Number(l.residualQty) > 0)
    .sort((a, b) => Number(b.residualQty) - Number(a.residualQty))
    .slice(0, 20);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('dashboard.lotResiduo.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        {lotsQ.isLoading && <p className="text-sm text-slate-500">{t('common.loading')}</p>}
        {!lotsQ.isLoading && top.length === 0 && (
          <p className="text-sm text-slate-500">{t('dashboard.lotResiduo.empty')}</p>
        )}
        {top.length > 0 && (
          <div className="max-h-72 overflow-y-auto">
            <table className="w-full text-xs">
              <thead className="border-b border-slate-200 bg-slate-50">
                <tr>
                  <th className="px-2 py-1 text-left font-medium text-slate-600">
                    {t('dashboard.lotResiduo.col.lot')}
                  </th>
                  <th className="px-2 py-1 text-left font-medium text-slate-600">
                    {t('dashboard.lotResiduo.col.product')}
                  </th>
                  <th className="px-2 py-1 text-right font-medium text-slate-600">
                    {t('dashboard.lotResiduo.col.residual')}
                  </th>
                  <th className="px-2 py-1 text-center font-medium text-slate-600">
                    {t('dashboard.lotResiduo.col.market')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {top.map((l) => (
                  <tr key={l.id} className="border-b border-slate-100 last:border-0">
                    <td className="px-2 py-1 font-mono">
                      <Link className="text-brand-700 hover:underline" to={`/lots/${l.id}/edit`}>
                        {l.code}
                      </Link>
                    </td>
                    <td className="px-2 py-1 text-slate-700">{l.productCode}</td>
                    <td className="px-2 py-1 text-right font-mono">
                      {Number(l.residualQty).toFixed(0)} g
                    </td>
                    <td className="px-2 py-1 text-center text-slate-500">
                      {l.targetCountry ?? '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
